export default "__VITE_ASSET__CsJS4LyO__"